import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Качество материала`,
    content: {
      description: `
        <p>
          Термокружка 400 мл.<br>
          Высота 17 см.<br>
          Диаметр сверху - 8 см, снизу - 6,5 см.
        </p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
